import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=ed52f206&scoped=true"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"
import style0 from "./Page.vue?vue&type=style&index=0&id=ed52f206&prod&scoped=true&lang=css"
import style1 from "./Page.vue?vue&type=style&index=1&id=ed52f206&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f1c606d12331ca9397f00d9371f47138/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed52f206",
  null
  
)

export default component.exports